/*
 * Copyright (c) 2025, Glasswing AI, Inc.
 * All rights reserved.
 */
import { createBrowserRouter } from 'react-router';
import App from './components/App.jsx';
import DashOverview from './components/DashOverview';
import DashSummary from './components/DashSummary';
import DashExecStatus from './components/DashExecStatus';
import ScanResultsPage from './components/ScanResultsPage';
import FingerprintsPage from './components/FingerprintsPage';
import FingerprintPage from './components/FingerprintPage';
import FingerProbesPage from './components/FingerProbesPage';
import Categories from './components/Categories';
import SupercatCategoriesPage from './components/SupercatCategoriesPage';
import WorkingSetTools from './components/WorkingSetTools';
import PendingDeletesPage from './components/PendingDeletesPage';
import MergeQueuePage from './components/MergeQueuePage';
import MergeLayerPage from './components/MergeLayerPage';
import MergeOpPage from './components/MergeOpPage';
import ShowChangesPage from './components/dataops/ShowChangesPage';
import ExportTools from './components/ExportTools';
import ThreatStopPage from './components/dataops/ThreatStopPage';
import DashProgress from './components/DashProgress';
import ProgressRefreshPage from './components/dataops/ProgressRefreshPage';
import ProbeEditor from './components/ProbeEditor';
import ProbePage from './components/ProbePage';
import ExecPage from './components/ExecPage';
import ProbeRootsPage from './components/ExecPage2';
import AiOpEditor from './components/AiOpEditor';
import AiContextEditor from './components/AiContextEditor';
import GeoPage from './components/GeoPage';
import AiOps from './components/AiOps';
import AiOpsGraph from './components/AiOpsGraph';
import AiConnectors from './components/AiContexts';
import AiLeads from './components/AiLeads';
import AiOpSelector from './components/AiOpSelector';
import SettingsLayout from './components/SettingsLayout';
import IdentitySettings from './components/settings/IdentitySettings';
import DisplaySettings from './components/settings/DisplaySettings';
import SoundsSettings from './components/settings/SoundsSettings';
import MetadataSettings from './components/settings/MetadataSettings';
import NetworkSettings from './components/settings/NetworkSettings';
import TaskManagerSettings from './components/settings/TaskManagerSettings';
import FuzzyMatchingSettings from './components/settings/FuzzyMatchingSettings';
import AdvancedSettings from './components/settings/AdvancedSettings';
import AboutSettings from './components/settings/AboutSettings';
import UpdatesSettings from './components/settings/UpdatesSettings';
import DiagnosticsSettings from './components/settings/DiagnosticsSettings';
import DeveloperSettings from './components/settings/DeveloperSettings';
import OpsSettings from './components/settings/OpsSettings';
import LoginPage from './components/LoginPage';
import UserManagementSettings from './components/settings/UserManagementSettings';
import AuthEventsSettings from './components/settings/AuthEventsSettings';
import DevPage from './components/DevPage';
import OpsPage from './components/OpsPage';

let router = createBrowserRouter([
    {
        path: '/login',
        element: <LoginPage />,
    },
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: 'dashboard/overview',
                element: <DashOverview />,
            },
            {
                path: 'dashboard/exec-status',
                element: <DashExecStatus />,
            },
            {
                path: 'dashboard/summary',
                element: <DashSummary />,
            },
            {
                path: 'dashboard/progress',
                element: <DashProgress />,
            },
            {
                path: 'dashboard/scan-results',
                element: <ScanResultsPage />,
            },
            {
                path: 'fingerprints',
                element: <FingerprintsPage />,
            },
            {
                path: 'fingerprint/:fid',
                element: <FingerprintPage />,
            },
            {
                path: 'fingerprint/:fid/probes',
                element: <FingerProbesPage />,
            },
            {
                path: 'categories',
                element: <Categories />,
            },
            {
                path: 'categories/:category',
                element: <Categories />,
            },
            {
                path: 'supercat/:supercat',
                element: <SupercatCategoriesPage />,
            },
            {
                path: 'ai/edit_op/:opid',
                element: <AiOpEditor />,
            },
            {
                path: 'ai/edit_context/:contextId',
                element: <AiContextEditor />,
            },
            {
                path: 'ai/edit_connector/:connectorId',
                element: <AiContextEditor />,
            },
            {
                path: 'data/ws',
                element: <WorkingSetTools />,
            },
            {
                path: 'data/pending-deletes',
                element: <PendingDeletesPage />,
            },
            {
                path: 'data/merge',
                element: <MergeQueuePage />,
            },
            {
                path: 'data/merge-db',
                element: <MergeQueuePage />,
            },
            {
                path: 'data/merge-layers',
                element: <MergeLayerPage />,
            },
            {
                path: 'data/merge-op',
                element: <MergeOpPage />,
            },
            {
                path: 'data/show-changes',
                element: <ShowChangesPage />,
            },
            {
                path: 'data/export',
                element: <ExportTools />,
            },
            {
                path: 'data/threatstop',
                element: <ThreatStopPage />,
            },
            {
                path: 'data/progress-refresh',
                element: <ProgressRefreshPage />,
            },
            {
                path: 'dev',
                element: <DevPage />,
            },
            {
                path: 'dev/:tab',
                element: <DevPage />,
            },
            {
                path: 'ops',
                element: <OpsPage />,
            },
            {
                path: 'probe',
                element: <ProbePage />,
            },
            {
                path: 'probe/:probeId',
                element: <ProbeEditor />,
            },
            {
                path: 'probe/exec',
                element: <ExecPage />,
            },
            {
                path: 'probe/roots',
                element: <ProbeRootsPage />,
            },
            {
                path: 'geo',
                element: <GeoPage />,
            },
            {
                path: "ai/ops",
                element: <AiOps />,
            },
            {
                path: "ai/opg",
                element: <AiOpsGraph />,
            },
            {
                path: "ai/contexts",
                element: <AiConnectors />,
            },
            {
                path: "ai/connectors",
                element: <AiConnectors />,
            },
            {
                path: "ai/leads",
                element: <AiLeads />,
            },
            {
                path: "ai/op-selector",
                element: <AiOpSelector />,
            },
            {
                path: "settings",
                element: <SettingsLayout />,
                children: [
                    {
                        index: true,
                        element: <DisplaySettings />,
                    },
                    {
                        path: "identity",
                        element: <IdentitySettings />,
                    },
                    {
                        path: "display",
                        element: <DisplaySettings />,
                    },
                    {
                        path: "sounds",
                        element: <SoundsSettings />,
                    },
                    {
                        path: "metadata",
                        element: <MetadataSettings />,
                    },
                    {
                        path: "network",
                        element: <NetworkSettings />,
                    },
                    {
                        path: "task-manager",
                        element: <TaskManagerSettings />,
                    },
                    {
                        path: "fuzzy-matching",
                        element: <FuzzyMatchingSettings />,
                    },
                    {
                        path: "advanced",
                        element: <AdvancedSettings />,
                    },
                    {
                        path: "diagnostics",
                        element: <DiagnosticsSettings />,
                    },
                    {
                        path: "about",
                        element: <AboutSettings />,
                    },
                    {
                        path: "updates",
                        element: <UpdatesSettings />,
                    },
                    {
                        path: 'users',
                        element: <UserManagementSettings />,
                    },
                    {
                        path: 'events',
                        element: <AuthEventsSettings />,
                    },
                    {
                        path: 'developer',
                        element: <DeveloperSettings />,
                    },
                    {
                        path: 'ops',
                        element: <OpsSettings />,
                    },
                ],
            },
        ],
    }
]);

export default router;